module.exports = __webpack_public_path__ + "static/img/irole.fd5fb85.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/tysdags/irole.png
// module id = MjTx
// module chunks = 7